import { UserActions } from '../actions';

export const users = (state = null, actions) => {
  switch (actions.type) {
    case UserActions.FETCH_USERS:
      return Object.assign({}, state, { fetching: true });
    case UserActions.USERS_RECEIVED:
      return Object.assign({}, state, { fetching: false, list: actions.users });
    default:
      return state;
  }
}

export default users;


// WEBPACK FOOTER //
// ./src/reducers/users.js